module.exports = __webpack_public_path__ + "img/S3.c2698dc5.png";